<template>
  <div class="app flex-row align-items-center page-login">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card no-body border-variant="none">
            <img src="img/logo.svg">
            <b-card-body class="ml-4 mr-4 mb-4">
              <router-view></router-view>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'UnauthorizedContainer',
    }
</script>
